/* Volnost product page: bundle block, add to cart, sliders, reviews */
(function () {
  if (window.__amvPdp) return;
  window.__amvPdp = true;
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* ---------- bundle block ---------- */
  function initBundle() {
    const box = document.getElementById('amv-bundle');
    if (!box) return;
    const bars = box.querySelectorAll('.amv-bdl__bar');
    bars.forEach((bar) => {
      const input = bar.querySelector('input[type=radio]');
      const select = () => {
        bars.forEach((b) => b.classList.toggle('amv-bdl__bar--selected', b === bar));
        input.checked = true;
      };
      input.addEventListener('change', select);
      bar.querySelector('.amv-bdl__bar-main').addEventListener('click', select);
    });
    box.querySelectorAll('.amv-bdl__swatch-dropdown').forEach((dd) => {
      const trigger = dd.querySelector('.amv-bdl__bar-variant-select');
      const list = dd.querySelector('.amv-bdl__swatch-dropdown__options');
      const close = () => { list.hidden = true; trigger.setAttribute('aria-expanded', 'false'); };
      // the list is position:fixed: put it under the trigger, or above it when there is no room below
      const place = () => {
        if (list.hidden) return;
        const r = trigger.getBoundingClientRect();
        list.style.minWidth = r.width + 'px';
        const h = list.offsetHeight;
        const below = window.innerHeight - r.bottom - 8;
        list.style.top = (below >= h || below >= r.top ? r.bottom + 4 : Math.max(8, r.top - h - 4)) + 'px';
        list.style.left = Math.max(8, Math.min(r.left, window.innerWidth - list.offsetWidth - 8)) + 'px';
      };
      trigger.addEventListener('click', (e) => {
        e.preventDefault(); e.stopPropagation();
        const open = list.hidden;
        box.querySelectorAll('.amv-bdl__swatch-dropdown__options').forEach((l) => { l.hidden = true; });
        list.hidden = !open;
        trigger.setAttribute('aria-expanded', String(open));
        place();
      });
      window.addEventListener('scroll', place, { passive: true });
      window.addEventListener('resize', place);
      list.querySelectorAll('.amv-bdl__swatch-dropdown__option').forEach((opt) => {
        opt.addEventListener('click', (e) => {
          e.preventDefault(); e.stopPropagation();
          dd.dataset.variantId = opt.dataset.variantId;
          trigger.querySelector('.amv-bdl__swatch').style.setProperty('--amvk-swatch-image-url', 'url(' + opt.dataset.sw + ')');
          trigger.querySelector('span').textContent = opt.querySelector('span').textContent;
          close();
        });
      });
      document.addEventListener('click', (e) => { if (!dd.contains(e.target)) close(); });
    });
  }

  function selectedItems() {
    const bar = document.querySelector('#amv-bundle .amv-bdl__bar--selected');
    if (!bar) return null;
    const counts = {};
    bar.querySelectorAll('.amv-bdl__swatch-dropdown').forEach((dd) => {
      counts[dd.dataset.variantId] = (counts[dd.dataset.variantId] || 0) + 1;
    });
    return Object.keys(counts).map((id) => ({ id: Number(id), quantity: counts[id] }));
  }

  function initForm() {
    document.querySelectorAll('.amv form[action$="/cart/add"]').forEach((form) => {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const btn = form.querySelector('[type=submit]');
        const items = selectedItems() || [{ id: Number(form.querySelector('[name=id]').value), quantity: 1 }];
        btn.setAttribute('aria-disabled', 'true');
        btn.classList.add('loading');
        try {
          const res = await fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items }),
          });
          if (!res.ok) throw new Error('add failed');
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          setTimeout(() => {
            if (!document.querySelector('.moonbundle-cart-drawer-content')) window.location.href = root + 'cart';
          }, 1800);
        } catch (err) {
          window.location.href = root + 'cart';
        } finally {
          btn.removeAttribute('aria-disabled');
          btn.classList.remove('loading');
        }
      });
    });
  }

  /* ---------- splide sliders (community / videos) ---------- */
  function initSplides() {
    if (!window.Splide) return;
    document.querySelectorAll('.amv splide-component').forEach((el) => {
      if (el.dataset.amvInit) return;
      el.dataset.amvInit = '1';
      const d = el.dataset;
      const splideEl = el.querySelector('.splide');
      new Splide(splideEl, {
        type: d.type === 'loop' ? 'loop' : 'slide',
        perPage: Number(d.slidesDesktop || 3),
        perMove: Number(d.perMoveDesktop || 1),
        gap: Number(d.gapDesktop || 0) + 'px',
        omitEnd: d.omitEnd === 'true',
        focus: 0,
        arrows: true,
        pagination: true,
        mediaQuery: 'max',
        breakpoints: { 749: { perPage: Number(d.slidesMobile || 1), perMove: Number(d.perMoveMobile || 1), gap: Number(d.gapMobile || 0) + 'px' } },
      }).mount();
    });
  }

  /* ---------- reviews ---------- */
  function initReviews() {
    const box = document.getElementById('amv-reviews');
    if (!box) return;
    const list = box.querySelector('.amv-rv__list');
    const items = Array.from(list.children);
    const original = items.slice();
    let page = 1, photoOnly = false;
    const pages = box.querySelectorAll('.amv-rv__page');
    function render() {
      let visible = items.filter((it) => !photoOnly || it.dataset.photo === '1');
      const perPage = 5;
      const maxPage = Math.max(1, Math.ceil(visible.length / perPage));
      page = Math.min(page, maxPage);
      items.forEach((it) => { it.hidden = true; });
      visible.slice((page - 1) * perPage, page * perPage).forEach((it) => { it.hidden = false; });
      pages.forEach((p) => {
        p.classList.toggle('is-active', Number(p.dataset.page) === page);
        p.hidden = Number(p.dataset.page) > maxPage;
      });
    }
    pages.forEach((p) => p.addEventListener('click', () => { page = Number(p.dataset.page); render(); box.scrollIntoView({ behavior: 'smooth' }); }));
    box.querySelector('.amv-rv__prev').addEventListener('click', () => { if (page > 1) { page--; render(); } });
    box.querySelector('.amv-rv__next').addEventListener('click', () => { page++; render(); });
    const filter = box.querySelector('.amv-rv__filter');
    filter.addEventListener('click', () => { photoOnly = !photoOnly; filter.setAttribute('aria-pressed', String(photoOnly)); page = 1; render(); });
    box.querySelector('select').addEventListener('change', (e) => {
      const v = e.target.value;
      const sorted = items.slice().sort((a, b) => {
        if (v === 'high') return b.dataset.rating - a.dataset.rating;
        if (v === 'low') return a.dataset.rating - b.dataset.rating;
        if (v === 'photo') return b.dataset.photo - a.dataset.photo;
        return original.indexOf(a) - original.indexOf(b);
      });
      sorted.forEach((it) => list.appendChild(it));
      items.splice(0, items.length, ...sorted);
      page = 1; render();
    });
    list.querySelectorAll('.amv-rv__body').forEach((b) => {
      b.classList.add('is-clamped');
      const more = document.createElement('button');
      more.type = 'button'; more.className = 'amv-rv__more'; more.textContent = 'Leer más';
      more.addEventListener('click', () => { b.classList.remove('is-clamped'); more.remove(); });
      b.after(more);
    });
    render();
  }

  function init() { initBundle(); initForm(); initSplides(); initReviews(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', initSplides);
})();
